import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import Select from 'react-select';
import { getErrorMessageHtml } from "../../Utils/FormHelpers";
import { Controller } from "react-hook-form";

export const SelectInput = (props) => {
    const {
        control,
        name,
        translationIndex,
        label,
        errors,
        setValue = null,
        options = [{ id: 1, value: "Test", label: "Alrighy?" }],
        multiple = false,
        currentValue = null,
        clearable = false,
        helperText = null,
        className = '',
        isDisabled = false,
    } = props;
    const { t } = useTranslation();
    const [currentSelected, setCurrentSelected] = useState([]);

    useEffect(() => {
        if (Array.isArray(currentValue)) {
            setCurrentSelected(options.filter(option => currentValue.includes(option.value)));
        } else {
            setCurrentSelected(options.find(option => option.value === currentValue) || null);
        }
    }, [currentValue, options]);

    return (
        <div className={`mb-2 ${className}`}>
            {(label || translationIndex) && (
                <label htmlFor={name}
                    className="block text-left text-sm font-medium leading-6 text-gray-900 mb-2">
                    {label || t(`${translationIndex}`)}
                </label>
            )}

            <Controller
                name={name}
                control={control}
                render={({ field, fieldState }) => (
                    <Select
                        {...field}
                        className={className}
                        placeholder={t('form.select_placeholder')}
                        onChange={(newValue) => {
                            if (multiple) {
                                const value = newValue ? newValue.map(option => option.value) : [];
                                if (setValue) setValue(name, value);
                                field.onChange(value);
                            } else {
                                const value = newValue?.value || null;
                                if (setValue) setValue(name, value);
                                field.onChange(value);
                            }
                        }}
                        onBlur={field.onBlur}
                        classNames={{
                            control: (state) =>
                                `focus:outline-none ring-0 ${state.isFocused ? 'border-red-600' : 'border-grey-300'}`,
                            option: (state) =>
                                `focus:outline-none ring-0 ${state.isFocused ? 'bg-primary text-white' : 'bg-white text-gray-900'}`,
                            menu: () => 'z-100',
                        }}
                        value={
                            multiple
                                ? options.filter(option => (field.value || []).includes(option.value))
                                : options.find(option => option.value === field.value) || null
                        }
                        isMulti={multiple}
                        isSearchable={true}
                        options={options}
                        isClearable={clearable}
                        isDisabled={isDisabled}
                    />
                )}
            ></Controller>

            {helperText && <span className="block text-xs text-gray-500 mt-1">{helperText}</span>}

            {getErrorMessageHtml(errors, name)}
        </div>
    )
}
